<div class="rotating-button" (click)="clicked.emit()">
    <div>{{text | transformText}}</div>
    <div>{{text | transformText}}</div>
    <div>{{text | transformText}}</div>
    <div>{{text | transformText}}</div>
</div>